class APIS {
	apis() {
		return {
			fbid: {
				headers: {
					// 'xt-user-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRUb2tlbklkIjoiYWIzOGNiZDYtOTBkMS00ZDY4LWIwMzMtYWQ5ZTUzZGQ2YjQ0IiwiY2xpZW50VXVpZCI6IjkxNjJkNjIwLTQ1NWUtNDAwNi04ZTM5LWNhNmZhZTEyYzA0MCIsImNsaWVudCI6IjEiLCJhY3RvciI6IjEiLCJ1c2VyVG9rZW5JZCI6IjQzNTZjMzc0LWY1MjAtNDk2ZC1hYzFkLThjNDU4MDFlNzUxMyIsInRpbWUiOjE2OTUxMTI5ODkyNzAsIm1heF90b2tlbl9jb3VudCI6LTEsImlhdCI6MTY5NTExMjk4OX0.zm3JSAWnEQl6an4_NukURr0X8-1P8mpfE5iC7V_4i2Y'
					'xt-user-token': null
				},
				method: 'post',
				path: '/onboarding/fb'
				// path: '/backend/client/fb'
			},
			instaOnboard: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/onboarding/instagram'
				// path: '/backend/client/fb'
			},
			whatsAppOnboard: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/onboarding/whatsapp'
				// path: '/backend/client/fb'
			},

			fbPageslist: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fb/pages'
			},
			instaPageslist: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/instagram/pages'
			},
			editChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/update/fb'
			},
			deleteFbChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/unsubscribe/fb'
			},
			deleteFbPostChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/unsubscribe/fb-post'
			},
			deleteInstaChannel: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/unsubscribe/instagram'
			},
			whatsappOnboardCheck: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/onboarding/whatsapp/status'
			},
			fbPageOnboard: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/onboarding/fb-pages'
			},
			emailSenderDomainList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-sender-domains/list'
			},
			emailSenderDomainAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-sender-domains/add'
			},
			emailSenderDomainUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-sender-domains/update'
			},
			emailSenderDomainDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-sender-domains/delete'
			}
		};
	}
}

export default new APIS();
